import React from 'react';
import { CircleLoader } from '@/components/CircleLoader';
import { useTranslation } from 'react-i18next';
import { Offset } from '@/components/Offset';
import { Group } from '@/components/Group';
import { Text } from '@/components/Text';
import { Actions, Content, Loader } from './styles';
import { tk } from '@/i18n/translationKeys';
import { useTheme } from 'styled-components';
import { Button } from '@devsbb/ui';

interface DeleteDialogProps {
  onConfirm: () => void;
  onCancel: () => void;
  inProgress?: boolean;
  text: string;
}

export const DeleteDialog = ({ onConfirm, onCancel, inProgress, text }: DeleteDialogProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <>
      <Content invisible={inProgress}>
        <Offset bottom={4}>
          <Text typography="SmallHeadline" color={theme.colors.text.darkerGrey}>
            {t(tk.deletePaymentMethodConfirmationDialogTitle)}
          </Text>
        </Offset>

        <Offset bottom={8}>
          <Text typography="RegularParagraph" color={theme.colors.text.darkGrey}>
            {text}
          </Text>
        </Offset>

        <Actions>
          <Button fullWidth onClick={onCancel} variant="SecondaryOutlined">
            {t(tk.deletePaymentMethodConfirmationDialogCancelButtonText)}
          </Button>
          <Button fullWidth onClick={onConfirm} variant="Red">
            {t(tk.deletePaymentMethodConfirmationDialogConfirmButtonText)}
          </Button>
        </Actions>
      </Content>

      {inProgress ? (
        <Loader>
          <Group centered vertical gap={3}>
            <CircleLoader />

            <Text typography="RegularParagraph" color={theme.colors.text.darkGrey}>
              {t(tk.deletePaymentMethodConfirmationDialogLoadingText)}
            </Text>
          </Group>
        </Loader>
      ) : null}
    </>
  );
};
